import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=389c9a0d"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389c9a0d')) {
      api.createRecord('389c9a0d', component.options)
    } else {
      api.reload('389c9a0d', component.options)
    }
    module.hot.accept("./HeaderPage.vue?vue&type=template&id=389c9a0d", function () {
      api.rerender('389c9a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/HeaderPage.vue"
export default component.exports